import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { descriptionColumn, textColumn } from '../../../../shared/components/kit/table/table.fields';
import { router } from '../../../../shared/shared.global-service';
import { ActivatedRoute } from '@angular/router';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { SubscriptionComponent } from '../../../../shared/helpers/subscription.component';
import { ServiceNursingDiagnosesPageStore } from './service-nursing-diagnoses-page.store';
import { ServiceNursingDiagnosesPageStore2 } from './service-nursing-diagnoses-page.store2';
import { CardTableComponent } from '../../../../shared/components/kit/table/card-table.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-service-nursing-diagnoses-page',
    templateUrl: './service-nursing-diagnoses-page.component.html',
    styleUrl: './service-nursing-diagnoses-page.component.scss',
    providers: [ServiceNursingDiagnosesPageStore, ServiceNursingDiagnosesPageStore2],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CardTableComponent,
        AsyncPipe,
    ],
})
export class ServiceNursingDiagnosesPageComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceNursingDiagnosesPageStore);
    protected readonly store2 = inject(ServiceNursingDiagnosesPageStore2);
    private readonly route = inject(ActivatedRoute);
    private readonly confirm = inject(ConfirmBuilder);
    protected serviceId = 0;

    protected columns = [
        textColumn('code'),
        textColumn('title'),
        textColumn('groupName'),
        descriptionColumn,
    ];

    constructor() {
        super();
        this.store.refreshGrid('getServiceNursingCareDiagnosisCodes', 'deleteServiceNursingCareDiagnosisCode');

        this.store.registerSuccessMessage('deleteServiceNursingCareDiagnosisCode', 'common.deleted');
        this.subs.push(
            this.store.routeParam.serviceId.subscribe((serviceId) => {
                this.serviceId = Number(serviceId || 0);
            }),
        );
    }

    protected async goTo(item?: any): Promise<void> {
        await router.navigate([`${item ? item.id : 'create'}`], { relativeTo: this.route });
    }

    protected deleteDiagnosis(item: any): void {
        this.confirm.confirm(
            'common.delete',
            null,
            () => this.store.api.deleteServiceNursingCareDiagnosisCode({ id: item.item.id }),
            null,
            'pi-trash',
            item.event.target,
        );
    }
}
